const shingleColorIdentity = shingle => {
  const data = shingle?.results?.data;
  const color = data?.shingle_colors?.[0];

  if (color?.uuid) return color.uuid;
  if (!data?.uid || !color?.uid) return null;

  return `${data.uid}:${color.uid}`;
};

export const isSameShingleColor = (firstShingle, secondShingle) => {
  const firstIdentity = shingleColorIdentity(firstShingle);
  const secondIdentity = shingleColorIdentity(secondShingle);

  return firstIdentity !== null && firstIdentity === secondIdentity;
};

export default shingleColorIdentity;
